import userService from "./userService";
import { accessGuard, getServerURL } from "../shared/sharedFunctions";

const ReportService = () => {
	const pub = {};
	
	pub.exposureReport = (company, exposureReportDetails, useClearbitLogo, advanced) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/exposurereport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		url += `/${exposureReportDetails.compromisedAccounts}`;
		url += `/${exposureReportDetails.passwordsLeaked}`;
		url += `/${exposureReportDetails.dataItemsLeaked}`;
		url += `/${useClearbitLogo}`;
		url += `/${advanced}`;
		window.open(url);
	};
	
	pub.executiveSummary = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/executivesummary/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.attackerViewReport = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/attackerviewreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.riskReductionReport = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/riskreductionreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.cyberRiskReport = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/cyberriskreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.darkWebReport = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/darkwebreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.cyberTrainingReport = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/cybertrainingreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.policyProcessReport = (company) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/policyprocessreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		window.open(url);
	};
	
	pub.vulnerabilityScanReport = (company, vscanReportId) => {
		if (!accessGuard([1, 2, 3])) return;
		let url = `${getServerURL()}/api/files/vulnerabilityscanreport/${userService.AccessToken()}`;
		url += `/${company.id}`;
		url += `/${vscanReportId}`;
		window.open(url);
	}
	
	return pub;
};

export default ReportService();
